import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.assign";

var _NODES_NAMES$formula$;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { FormulaModel, TableModel } from "@reactivepad/core";
import { APP_NAME } from "./config";
export var NODES_NAMES = {
  formula: APP_NAME + "_formula",
  table: APP_NAME + "_table"
};
var DEFAULT_ATTR_VALUE = null;

var mapPropertyNamesToAttrs = function mapPropertyNamesToAttrs(_ref) {
  var propertyNames = _ref.propertyNames;
  return propertyNames.reduce(function (acc, next) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[next] = {
      "default": DEFAULT_ATTR_VALUE
    }, _extends2));
  }, {});
}; // ToDo: write tests that will ensure correctness of attrs


export default (_NODES_NAMES$formula$ = {}, _NODES_NAMES$formula$[NODES_NAMES.formula] = {
  attrs: mapPropertyNamesToAttrs(FormulaModel),
  inline: true,
  group: "inline",
  atom: true,
  // toDOM is used in copying (ctrl-c); parseDOM is used to bring back node
  toDOM: function toDOM(_ref2) {
    var attrs = _ref2.attrs;
    return "" + attrs.formatted;
  }
}, _NODES_NAMES$formula$[NODES_NAMES.table] = {
  attrs: mapPropertyNamesToAttrs(TableModel),
  group: "block",
  atom: true,
  isolating: true,
  selectable: false,
  draggable: false,
  toDOM: function toDOM(_ref3) {
    var attrs = _ref3.attrs;
    return attrs.name;
  }
}, _NODES_NAMES$formula$);